import { Play } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { Reveal, SectionHead } from "@/components/Reveal";
import { VIDEOS } from "@/data";

const YTEmbed = ({ id, title, testId, className = "" }) => (
  <div className={`relative aspect-video bg-card2 border border-ivory/10 overflow-hidden ${className}`} data-testid={testId}>
    <iframe
      className="absolute inset-0 w-full h-full"
      src={`https://www.youtube-nocookie.com/embed/${id}?rel=0`}
      title={title}
      loading="lazy"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    />
  </div>
);

export const Videos = () => {
  const { t, lang } = useLanguage();
  const featured = VIDEOS.find((v) => v.featured);
  const rest = VIDEOS.filter((v) => !v.featured);

  return (
    <section id="videos" data-testid="videos-section" className="py-24 lg:py-36">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <SectionHead title={t.videos.title} sub={t.videos.sub} testId="videos-title" />

        <Reveal className="mt-14">
          <YTEmbed id={featured.id} title={featured.title} testId="video-featured" />
          <div className="mt-4 flex items-center justify-between">
            <p className="font-serif text-lg text-champagne">{featured.title}</p>
            <span className="gc-eyebrow !text-[9px]">{featured.tag[lang] ?? featured.tag.en}</span>
          </div>
        </Reveal>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {rest.map((v, i) => (
            <Reveal key={v.id} delay={(i % 3) * 0.1}>
              <YTEmbed id={v.id} title={v.title} testId={`video-${v.id}`} />
              <div className="mt-3 flex items-start gap-2">
                <Play className="w-3.5 h-3.5 text-gold mt-1 shrink-0" strokeWidth={1.5} />
                <div>
                  <p className="text-sm text-ash">{v.title}</p>
                  <p className="text-[10px] tracking-[0.2em] uppercase text-dim mt-1">{v.tag[lang] ?? v.tag.en}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
